/**
 * Copyright © 2026 Adnuntius AS.
 */
import {Component, Inject} from '@angular/core';
import template from './report-schedule-list-page.component.html';

import {AdminListColumn, AdminResourceListPageBase} from '../common/controller/admin-resource-list-page-base';
import {LocalNetworkProfile} from '../../components/session/local-network-profile';

@Component({
  standalone: false,
  selector: 'adn-report-schedule-list-page',
  template
})
export class ReportScheduleListPageComponent extends AdminResourceListPageBase {
  readonly itemStateName = 'app.rep.report-schedules.report-schedule';
  readonly reportTemplateStateName = 'app.rep.report-templates.report-template';

  columns: AdminListColumn[] = [
    {param: 'name'},
    {label: 'reportTemplate', param: '', sortable: false},
    {label: 'staticUrl', param: '', sortable: false},
    {param: 'recurrence'},
    {param: 'period', label: 'reportDates'},
    {param: 'scheduledFor', label: 'nextExecution'}
  ];

  constructor(
    @Inject(LocalNetworkProfile) LocalNetworkProfile: any
  ) {
    super(LocalNetworkProfile);
  }

}
